import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import UserHistory from 'screens/userHistory';
import InlineStatsPanel from '.';
import { useFetchAssetPopularUsers } from 'actions/assets';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function AssetPopularUsersStats(_ref) {
  var _ref2;
  var assetId = _ref.assetId,
    parentId = _ref.parentId,
    playlistId = _ref.playlistId,
    title = _ref.title,
    _ref$isPanelLayout = _ref.isPanelLayout,
    isPanelLayout = _ref$isPanelLayout === void 0 ? false : _ref$isPanelLayout;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasModal = _useState2[0],
    setHasModal = _useState2[1];
  var _useFetchAssetPopular = useFetchAssetPopularUsers({
      assetId: assetId,
      parentId: parentId,
      playlistId: playlistId
    }),
    data = _useFetchAssetPopular.data,
    isLoading = _useFetchAssetPopular.isLoading,
    isError = _useFetchAssetPopular.isError;
  if (!data) return null;
  var id = (_ref2 = assetId !== null && assetId !== void 0 ? assetId : parentId) !== null && _ref2 !== void 0 ? _ref2 : playlistId;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(InlineStatsPanel, {
      isPanelLayout: isPanelLayout,
      title: title,
      data: data,
      onClick: function onClick() {
        return setHasModal(true);
      },
      isLoading: isLoading,
      isError: isError
    }), hasModal && /*#__PURE__*/_jsx(UserHistory, {
      title: t('analytics_most_active_users'),
      subtitle: name,
      moreLink: "/users/?search=openedasset:".concat(id),
      data: data,
      cols: [t('property_user_name'), t('property_opens')],
      onClose: function onClose() {
        return setHasModal(false);
      }
    })]
  });
}
export default AssetPopularUsersStats;